<template>
  <div class="two-columns">
    <div class="column column__left">
      <slot />
    </div>

    <div
      v-if="hasRightContent || experienceEditor"
      :class="['column', 'column__right', { 'column__right--sticky' : sticky }]"
    >
      <slot name="right" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TwoColumns',
    props: {
      experienceEditor: {
        type: Boolean,
        required: false,
        default: false
      },
      sticky: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    computed: {
      hasRightContent() {
        return !!this.$slots.right;
      }
    },
    mounted() {
      if (document.getElementById('main-container') && this.sticky) {
        document.getElementById('main-container').style.overflow = 'inherit';
      }
    }
  };
</script>
